import axios from 'axios';
import { COMMERCE_GRAPHQL_URL } from 'constants/config';
import { getGqlBody, GraphqlDocument } from './graphql';
import { getLocalStorage } from './localStorage';



interface GraphQLResponse<T> {
  data: T;
  errors?: Array<{ message: string }>;
}

export const graphqlRequest = async <T>(
  query: string | GraphqlDocument,
  variables?: Record<string, any>
): Promise<T> => {
  const queryString = typeof query === 'string' ? query : getGqlBody(query);

  const { data } = await axios.post<GraphQLResponse<T>>(
    `${COMMERCE_GRAPHQL_URL}/graphql`,
    { query: queryString, variables },
    {
      headers: {
        'Content-Type': 'application/json',
        'Account-Id': getLocalStorage('baId'),
        'Account-Type': 'business_profile',
      },
      withCredentials: true,
    }
  );

  if (data.errors && data.errors.length > 0) {
    throw new Error(data.errors[0].message);
  }

  return data.data;
};
